import { useMemo } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobileAlt } from '@fortawesome/free-solid-svg-icons/faMobileAlt';
import { AXNUIDefaultModal } from "@iddataweb/idw-common-ui/containers";
import { AXNUIContent } from "@iddataweb/idw-common-ui/types";
import { AXNUIThemingPreviewConfigurationState } from '@idw-types/common/axnui/axnui-theming-preview-configuration-state';
import styles from "./axnui-theming-async-modal.less";

type AXNUIThemingAsyncModalProps = {
	previewConfigurationState: AXNUIThemingPreviewConfigurationState;
	setPreviewConfigurationState: (state: AXNUIThemingPreviewConfigurationState) => void;
    axnuiContent: AXNUIContent;
};

export const AXNUIThemingAsyncModal = (props: AXNUIThemingAsyncModalProps) => {
	const {
		previewConfigurationState,
		setPreviewConfigurationState,
		axnuiContent
	} = props;

    const continueInfoText = useMemo(() => {
        if (previewConfigurationState.showContinueInfoEmail) {
            return axnuiContent.common.asyncModal.continueInfoEmail;
        } else {
            return axnuiContent.common.asyncModal.continueInfoPhone;
        }
    }, [previewConfigurationState.showContinueInfoEmail, axnuiContent.common.asyncModal.continueInfoEmail, axnuiContent.common.asyncModal.continueInfoPhone]);

    const asyncSubmissionText = useMemo(() => {
        if (previewConfigurationState.showAsyncSubmissionInProgress) {
            return axnuiContent.common.asyncModal.waiting;
        } else {
            return axnuiContent.common.asyncModal.complete;
        }
    }, [previewConfigurationState.showAsyncSubmissionInProgress, axnuiContent.common.asyncModal.waiting, axnuiContent.common.asyncModal.complete]);

	const onClickClose = () => {
		setPreviewConfigurationState({ ...previewConfigurationState, showAsyncModal: false });
	};

	return (
		<AXNUIDefaultModal
			ariaLabelledBy={"axnui-theming-async-modal-title"}
			className={styles.axnuiThemingAsyncModal}
			dialogClassName={styles.axnuiThemingAsyncModalDialog}
			isMaxWidth={false}
			onHide={undefined}
			show={true}
		>
			<Modal.Body className={styles.axnuiThemingAsyncModalBody}>
				<FontAwesomeIcon icon={faMobileAlt} className={styles.mobileIcon} />
				<span className={styles.textSpan} dangerouslySetInnerHTML={{
					__html: continueInfoText
				}} />
				<span id="async-details" className={styles.textSpan}>{axnuiContent.common.asyncModal.details}</span>
				<span id="async-message" className={styles.textSpan}>{asyncSubmissionText}</span>
			</Modal.Body>
			<Modal.Footer className={styles.axnuiThemingAsyncModalFooter}>
				{!previewConfigurationState.showNoRetriesLeft && (
					<Button
						id={"async-cancel-button"}
						variant={"secondary"}
						onClick={onClickClose}
					>
						{axnuiContent.common.asyncModal.cancel}
					</Button>
				)}
				{previewConfigurationState.showNoRetriesLeft && (
					<span id="async-noCancel">
						{axnuiContent.common.asyncModal.noRetriesLeft}
					</span>
				)}
			</Modal.Footer>
		</AXNUIDefaultModal>
	);
};